module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ec-Fb-Gd.5950bfba.png";